<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="standort-icon">
      <div class="inline-icon highlight" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
    </div>
    <h2 langkey="phFilterLayer_Title"></h2>
    <div class=filter-dialog-description>
      <span langkey="phFilterLayer_Description"></span>
    </div>
    <div class="ya-dialog-content">

      <ng-container *ngFor="let likedLocation of likedLocations">
        <div class="ya-dialog-aimation-list">
          <div class="ya-dialog-list-item">
            <div class="filter-item-content">
              <h3>{{likedLocation.label}}</h3>
              <span>{{likedLocation.street}}</span>
              <span>{{likedLocation.zip}} {{likedLocation.PostalCode}}</span>
            </div>
            <div class="filter-item-selected">
              <div class="inline-icon ya-favorite-svg likefiller" inlineSVG="shop-icons.svg#ya-favorite"></div>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="ya-dialog-aimation-list" #locationListView>
        <ng-container *ngFor="let location of locations">
          <a matRipple matRippleCentered="true" (click)="toggleFilterSelection(location)"
            [ngStyle]="location.topOffset">
            <div class="ya-dialog-list-item">
              <div class="filter-item-content">
                <h3>{{location.label}}</h3>
                <span>{{location.street}}</span>
                <span>{{location.zip}} {{location.PostalCode}}</span>
              </div>
              <div class="filter-item-selected">
                <ng-container *ngIf="location.selected">
                  <div class="inline-icon ya-favorite-svg" inlineSVG="shop-icons.svg#ya-done"></div>
                </ng-container>
              </div>
            </div>
          </a>
        </ng-container>
      </div>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-container">
        <button mat-flat-button (click)="saveFilter()"><span langkey="phFilterLayer_Filter"></span></button>
      </div>
    </div>
  </div>
</div>